import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useState } from 'react';
import { Image as RNImage, View, Text, TouchableWithoutFeedback } from 'react-native';
import FailToLoad from './FailToLoad';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useTracking } from '../../../hooks/rn/useTracking';
// TODO
// 2. preview
export var Image = function Image(props) {
  //   const context = useContext(ConfigContext);
  var propsSrc = props.src,
    fallbackSrc = props.fallback,
    fallbackText = props.fallbackText,
    _props$useFallback = props.useFallback,
    useFallback = _props$useFallback === void 0 ? true : _props$useFallback,
    propsStyles = props.styles,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    minWidth = props.minWidth,
    minHeight = props.minHeight,
    height = props.height,
    width = props.width,
    margin = props.margin;
  var _useState = useState(propsSrc),
    _useState2 = _slicedToArray(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var onError = function onError(err) {
    if (props.onError) {
      props.onError(err);
      return;
    }
    if (useFallback && fallbackSrc && src !== fallbackSrc) {
      setSrc(fallbackSrc);
    } else {
      setIsError(true);
    }
  };
  var onClick = function onClick() {
    var _props$onClick;

    // 点击埋点
    trackingClick && tracker.click(trackingClick);
    props === null || props === void 0 ? void 0 : (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, src); // preview && context?.eventEmitter?.emit?.(UIEvents.PreviewImage, { url: src });
  };

  useEffect(function () {
    if (!src) {
      setIsError(true);
    }
  }, [src]);
  return isError && fallbackText ? /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles.container), propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.containerStyle)
  }, /*#__PURE__*/React.createElement(Text, {
    style: _objectSpread({}, propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.textStyle)
  }, fallbackText)) : /*#__PURE__*/React.createElement(TouchableWithoutFeedback, _extends({
    onPress: onClick
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles.container), propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.containerStyle)
  }, isError ? /*#__PURE__*/React.createElement(FailToLoad, {
    style: _objectSpread({}, propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.errorSvgStyle)
  }) : /*#__PURE__*/React.createElement(RNImage, {
    source: {
      uri: src
    },
    onError: onError,
    style: _objectSpread(_objectSpread({
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      margin: margin,
      height: height !== null && height !== void 0 ? height : 100,
      width: width !== null && width !== void 0 ? width : 100
    }, styles.image), propsStyles === null || propsStyles === void 0 ? void 0 : propsStyles.imageStyle)
  })));
};
var styles = CustomStyleSheet({
  container: {
    backgroundColor: '#ffffff',
    maxWidth: '100%',
    textAlign: 'center',
    color: 'black'
  },
  image: {
    resizeMode: 'cover'
  }
});